module.exports = __webpack_public_path__ + "static/rappi-5-5003b5c1e8574e7e1554e7f012eca572.jpg";